import { createAction, handleActions } from "redux-actions";

const SET_LOADING = 'loading.SET_LOADING';
const CLEAR_LOADING = 'loading.CLEAR_LOADING';

const defaultState = {
  spinnerType : '1',
  isShowSpinner : false,
  isShowBall : false
};

const setLoadingAction = createAction( SET_LOADING, payload => payload );
const clearLoadingAction = createAction( CLEAR_LOADING );

const loading = handleActions( {
  [ SET_LOADING ] : ( state, action ) => ( { ...state, ...action.payload } ),
  [ CLEAR_LOADING ] : () => defaultState
}, defaultState );

export default loading;
export { setLoadingAction, clearLoadingAction };
